import { render, staticRenderFns } from "./Dreams.vue?vue&type=template&id=60f61c79&scoped=true"
import script from "./Dreams.vue?vue&type=script&lang=js"
export * from "./Dreams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f61c79",
  null
  
)

export default component.exports